import api from './axiosInstance';

export const obtenerPdf = async (url: string): Promise<Uint8Array> => {
    const response = await api.get(url, {
        responseType: "arraybuffer",
    });

    return new Uint8Array(response.data);
};
